module.exports = __webpack_public_path__ + "static/img/development-history.6958c47.png";


//////////////////
// WEBPACK FOOTER
// ./static/cooperate/development-history.png
// module id = zxBm
// module chunks = 1